import React from 'react';

function Logout() {
    const clearstate = ()=>{
        localStorage.clear();
        setTimeout(() => {
            window.location.href = '/login';
        }, 1500)
    }
    clearstate();
    return (
        <div style={{ maxWidth: '300px', margin: '0 auto' }} onClick={clearstate}>
            <h1>正在退出……</h1>
        </div>
    );
}

export default Logout;
